import React, { useEffect } from "react";
import { Box, Grid, Tooltip, Stack, Chip, Button, IconButton, Typography, useTheme, Divider, TextField, MenuItem, Paper, } from "@mui/material";
import { styled } from '@mui/material/styles';

//Hooks

//Controls

//Icons
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ReadMoreOutlinedIcon from '@mui/icons-material/ReadMoreOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhotoIcon from '@mui/icons-material/Photo';
import DeleteIcon from '@mui/icons-material/Delete';

import { tokens } from "../../../assets/theme";
import { useState } from "react";

// import messages from "./components/messages";
// import { FormattedMessage } from "react-intl";

const DrumList = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const states = [1, 2, 3, 4, 9];
    const stateNames = ["Regitered", "In progress", "Pick up", "Paid", "Ready"];
    const statesCount = [];
    const [filteredData, setfilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [showChildrenFor, setShowChildrenFor] = useState(0);


    function getManufacturerName(id) {
        let manufacturer = props.manufacturers?.find(x => x.id === id);
        if (manufacturer === undefined) {
            return "Unknown";
        }
        return manufacturer.manufacturer1;
    }

    function getDrumCount(data) {
        return data?.reduce((a, b) => a + (b['drumcount'] || 0), 0);
    }

    const DemoPaper = styled(Paper)(({ theme }) => ({
        //width: 120,
        //height: 120,
        backgroundColor: colors.primary[400],
        //paddingTop: theme.spacing(2),
        //...theme.typography.body2,
        textAlign: 'center',
    }));



    if (props.data === null) {
        return <Box color="white">Data is missing...</Box>;
    }
    console.log("Pling: ");
    console.log("Data: ", props.data);

    let content = <>
        <Box color={colors.primary[100]}>

            <Grid container alignItems="center" width="100%" height="" direction="row" spacing="1px" padding="10px">


                <Grid item xs={12}><Typography>Total number of drums: {getDrumCount(props.data?.returndrums)}</Typography></Grid>
                <Grid item xs={12} marginBottom="10px"><Divider color={colors.primary[900]} /></Grid>
                
                {props.data?.returndrums.map((drum, index) => {
                    return (<>

                        <Grid item xs={12} marginTop="5px" marginBottom="5px">
                            <DemoPaper square={false}>
                                {/* boxShadow={1} */}
                                <Stack direction="row" display="flex" alignContent="center" alignItems="center" spacing="auto" paddingTop="10px" paddingBottom="10px">
                                    <IconButton width="40px"><ReadMoreOutlinedIcon fontSize="medium" /></IconButton>
                                    <TextField id="outlined-basic" label="Type of drum" placeholder="Placeholder" variant="standard" defaultValue={drum?.reeltype.reeltype1} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                                    <TextField id="outlined-basic" label="Manufacturer" placeholder="Placeholder" variant="standard" defaultValue={getManufacturerName(drum?.manufacturerid)} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                                    <TextField id="outlined-basic" label="Nr. of items" placeholder="Placeholder" variant="standard" defaultValue={drum?.drumcount} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                                    <TextField
                                        id="standard-select-currency"
                                        select
                                        label="Quality"
                                        defaultValue="0"
                                        //helperText="Please select your currency"
                                        variant="standard"
                                        inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', width: '70px' } }}
                                    >
                                        {/* {currencies.map((option) => ( */}
                                        <MenuItem key={0} value={0}>
                                            {" "}
                                        </MenuItem>
                                        <MenuItem key={1} value={1}>
                                            {"Top grade"}
                                        </MenuItem>
                                        <MenuItem key={2} value={2}>
                                            {"Repairable"}
                                        </MenuItem>
                                        <MenuItem key={3} value={3}>
                                            {"Rejected"}
                                        </MenuItem>
                                        {/* ))} */}
                                    </TextField>
                                    <Stack direction="row" width="120px">
                                        <IconButton><CheckCircleIcon fontSize="medium" sx={{ color: colors.dashbordGreen[500] }} /></IconButton>
                                        <IconButton><PhotoIcon fontSize="medium" /></IconButton>
                                        <IconButton><DeleteIcon fontSize="medium" sx={{ color: colors.redAccent[500] }} /></IconButton>
                                    </Stack>

                                </Stack>
                            </DemoPaper>
                        </Grid>
                        {/* <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>     */}
                    </>)
                })}
                <Grid item xs={12} marginTop="5px" marginBottom="5px">
                    <DemoPaper square={false}>
                        {/* boxShadow={1} */}
                        <Stack direction="row" display="flex" alignContent="center" alignItems="center" spacing="auto" paddingTop="10px" paddingBottom="10px">
                            <Box width="40px"> </Box>
                            <TextField id="outlined-basic" label="Type of drum" placeholder="Placeholder" variant="standard" defaultValue={" "} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                            <TextField id="outlined-basic" label="Manufacturer" placeholder="Placeholder" variant="standard" defaultValue={" "} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                            <TextField id="outlined-basic" label="Nr. of items" placeholder="Placeholder" variant="standard" defaultValue={" "} inputProps={{ sx: { backgroundColor: '#fff', padding: '5px' } }} />
                            <TextField
                                id="standard-select-currency"
                                select
                                label="Quality"
                                defaultValue="0"
                                //helperText="Please select your currency"
                                variant="standard"
                                inputProps={{ sx: { backgroundColor: '#fff', padding: '5px', width: '70px' } }}
                            >
                                {/* {currencies.map((option) => ( */}
                                <MenuItem key={0} value={0}>
                                    {" "}
                                </MenuItem>
                                <MenuItem key={1} value={1}>
                                    {"Top grade"}
                                </MenuItem>
                                <MenuItem key={2} value={2}>
                                    {"Repairable"}
                                </MenuItem>
                                <MenuItem key={3} value={3}>
                                    {"Rejected"}
                                </MenuItem>
                                {/* ))} */}
                            </TextField>
                            <Box width="120px">
                                <Button
                                    sx={{
                                        backgroundColor: colors.dashbordGreen[500],
                                        "&:hover": {
                                            backgroundColor: colors.dashbordGreen[400],
                                            borderColor: "#5e7939",
                                            boxShadow: "none",
                                        },
                                        marginRight: "15px",
                                        // marginBottom: "15px",
                                    }}>Add drum</Button>
                            </Box>
                        </Stack>
                    </DemoPaper>
                </Grid>
                {/* <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid> */}
            </Grid>
        </Box>
    </>;

    return (
        <>
            {content}
        </>
    )
};

export default DrumList;
